import { orderSyncOrderToWechat, uaPaymentBlacklistListValidPaymentChannel, syncWxLiveOrderToWechat } from '@/api/order';
import { weChatPayJsApi } from '@/api/pay';
import { alert } from '@/utils/prompt';

const state = {
  paymentChannelList: [],
  izWxUnion: '0', // izWxUnion: 是否升级版微信交易组件 1:是 0:否"
};

const mutations = {
  SET_PAYMENT_CHANNEL_LIST(state, list = []) {
    state.paymentChannelList = list;
  },
};

const actions = {
  async listPaymentChannel({ commit }) {
    const data = await uaPaymentBlacklistListValidPaymentChannel();
    if (data.success && data.data) {
      const paymentChannelList = data.data.map(item => ({ ...item, text: item.payChannelName }));
      commit('SET_PAYMENT_CHANNEL_LIST', paymentChannelList);
    }
  },
  videoOrderSyncOrderToWechat(ctx, params) {


















    /* eslint-disable no-unreachable */
    return Promise.resolve({
      ticket: null,
    });

  },
  checkBeforeAddOrder({ commit }) {
    return new Promise((resolve) => {
      const commitIzWxUnion = (value) => {
        commit('$uStore', {
          name: 'vuexPay.izWxUnion',
          value,
        });
      };
      // 该接口基础库版本 >= 2.23.0 支持
      if (!wx.checkBeforeAddOrder) {
        // izWxUnion: 是否升级版微信交易组件 1:是 0:否"
        commitIzWxUnion('0');
        resolve({ islowVersion: true, izWxUnion: '0' });
        return;
      }
      wx.checkBeforeAddOrder({
        success (res) {
          console.log(res.data, 'checkBeforeAddOrder');
          const { requireOrder, requiredFundType } = res.data;
          const izWxUnion = requireOrder === 1 && requiredFundType === 1 ? '1' : '0';
          commitIzWxUnion(izWxUnion);
          resolve({ ...res.data, izWxUnion });
        },
        fail (err) {
          commitIzWxUnion('0');
          resolve({
            err,
            izWxUnion: '0',
          });
        },
      });
    });
  },
  // 获取微信小程序支付参数
  async getWeixinPayParams(ctx, params) {



































  },
};

export default {
  state,
  mutations,
  actions,
};
